/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Model } from '@app/shared/models/model.model';
import { UserRole } from '@app/settings/users/roles/user-role.model';
import { DateTime } from '@app/shared/models/date-time.model';
import { Locale } from '@app/settings/locales/locales.model';
import { Contact } from '@app/shared/components/contact/contact.model';
import { BankAccount } from '@app/shared/components/bank-accounts/bank-account.model';
import { Company } from '@app/settings/companies/company.model';
import { Type } from '@app/settings/types/types.model';
import { SmtpSettings } from '@app/shared/components/smtp-settings/smtp-settings.model';

export class UserSetting extends Model {
  id: number;
}

export class User extends Model {
  id: number;
  title_id: number;
  title: Type;
  first_name: string;
  middle_name: string;
  last_name: string;
  email: string;
  password?: string;
  roles?: Array<UserRole>;
  employee: Boolean;
  fake_first_name: string;
  fake_last_name: string;
  fake_email: string;
  address: string;
  address2: string;
  post_code: string;
  contacts: Array<Contact>;
  bank_accounts: Array<BankAccount>;
  egn?: string;
  company_id: number;
  company: Company;
  birthdate?: DateTime;
  gender?: DateTime;
  working_time_from?: string;
  working_time_to?: string;
  lunch_break?: string;
  city_id?: number;
  city?: number;
  salary_payment_method_id?: number;
  contract_start_date?: DateTime;
  contract_end_date?: DateTime;
  base_salary_amount?: DateTime;
  working_hours_per_week?: number;
  settings?: Array<UserSetting>;
  avatar: string;
  new_avatar?: string;
  active: boolean;
  locales: Array<Locale>;
  companies: Array<Company>;
  allowed_ip_addresses: Array<string>;
  smtp_settings: Array<SmtpSettings>;

  deserialize(input: any): this {
    super.deserialize(input);

    // if (input.roles) {
    //   input.roles.forEach((role: any) => {
    //     role = new UserRole().deserialize(role);
    //   });
    // }

    if (input.roles) {
      this.roles = input.roles.map((role: UserRole) => new UserRole().deserialize(role));
    }

    // if (input.settings) {
    //   input.settings.forEach((settings: any) => {
    //     settings = new UserSetting().deserialize(settings);
    //   });
    // }

    if (input.settings) {
      this.settings = input.settings.map((setting: UserSetting) => new UserSetting().deserialize(setting));
    }

    if (input.smtp_settings) {
      this.smtp_settings = input.smtp_settings.map((smtp_settings: SmtpSettings) =>
        new SmtpSettings().deserialize(smtp_settings)
      );
    }

    if (input.companies) {
      this.companies = input.companies.map((company: Company) => new Company().deserialize(company));
    }

    if (input.contacts) {
      this.contacts = input.contacts.map((contact: Contact) => new Contact().deserialize(contact));
    }

    if (input.title) {
      this.title = new Type().deserialize(input.title);
    }

    if (input.company) {
      this.company = new Company().deserialize(input.company);
    }

    return this;
  }

  /**
   * Names
   */
  get names(): string {
    return this.fake_first_name + ' ' + this.fake_last_name;
  }

  /**
   * Role names
   * @example Role1, Role2
   */
  getRolesNames(): string {
    if (this.roles == null || this.roles.length <= 0) {
      return '';
    }

    return this.roles
      .map((role) => {
        return role.name;
      })
      .join(', ');
  }
}
